import { gql } from "@apollo/client";

// Real-time push for every Messenger Calling event in the tenant.
// type values: ringing | accepted | rejected | in-progress | terminated
//              | media_update | permission_updated
//
// psid / pageId / permissionStatus / permissionExpiresAt are only set
// on permission_updated events — they let MessengerCallButton target
// the matching chat and decide whether to refetch the canonical
// permission state.
const MESSENGER_CALL_EVENT_SUBSCRIPTION = gql`
  subscription messengerCallEvent($mainSuperAdminId: ID!) {
    messengerCallEvent(mainSuperAdminId: $mainSuperAdminId) {
      type
      callId
      session
      psid
      pageId
      permissionStatus
      permissionExpiresAt
      call {
        id
        callId
        pageId
        psid
        inboxId
        mainSuperAdminId
        agentId
        direction
        status
        customerName
        customerPicture
        startTime
        answeredTime
        endTime
        durationSeconds
        hangupBy
        errorMessage
      }
    }
  }
`;

export default MESSENGER_CALL_EVENT_SUBSCRIPTION;
